<script setup>
const urlDemo = 'https://share-eu1.hsforms.com/1mIQmbipMQhSSWNdCSVNngAf2fjz';
const urlContacto = 'https://share-eu1.hsforms.com/1hZPFnruCRPybCXKgPGeYOAf2fjz';
</script>
<template>
  <div id="contacto">
    <div class="container">
      <div class="row">
        <div class="col-md-5 offset-md-1 mb-md-0 mb-4">
          <div class="empresa ms-md-auto bg-red">
            <h3>¿Eres <strong>Empresa?</strong></h3>

            <a :href="urlDemo" target="_blank" class="btn bg-white text-black btn-lg rounded-pill">Solicita una demo</a>
            <p>
              O escríbenos a
              <a href="mailto:ventas@mine-class.com">ventas@mine-class.com</a>
            </p>
          </div>
        </div>
        <div class="col-md-5">
          <div class="curso titulo-largo">
            <h3>
              ¿Eres <strong>persona independiente</strong> y quieres tomar un
              <strong>curso?</strong>
            </h3>

            <a :href="urlContacto" target="_blank" class="btn degrade-btn btn-lg rounded-pill">Contáctanos</a>
            <p>
              O escríbenos a <a href="mailto:hola@mine-class.com">hola@mine-class.com</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

#contacto {

  background: url(../assets/img/acceso-bg.jpg) no-repeat center;
  background-size: cover;
  padding: 55px 0;

  .empresa,
  .curso {
    height: 265px;
    flex-direction: column;
    gap: 30px;
    align-items: center;
    justify-content: center;
    color: #fff;
    max-width: 460px;
    padding: 20px 25px;
    
    display: flex;
    justify-content: center;
    align-items: center;

    border-radius: 49px;
    a {
      color: #fff;
      &:not(.btn) {
        text-decoration: underline;
      }
    }
    p {
      margin-bottom: 0;
    }

    &.titulo-largo {
      h3 {
        margin-bottom: -10px;
      }
    }
  }

  .empresa {
    background-color: #F05948;
  }
  .curso {
    background-color: #3B1064;
  }

  @media (max-width: 767px) {
    .curso,
    .empresa {
      margin: 0 auto;
    }
  }

  @media (min-width: 1200px) {
      .h3, h3 {
          font-size: 1.75rem;
      }
  }
  
}

</style>